import React from "react";
import PropTypes from "prop-types";

const NumberCell = ({ value, className }) => (
  <div className={className} style={{ width: "100%", textAlign: "right" }}>
    {value}
  </div>
);

NumberCell.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string
};

export default NumberCell;
